import {isFeatureEnabled} from 'feature-flags';

import {featureFlags} from '@dms/feature-flags';
import {percentageToDecimalValue} from '@dms/settings/shared';

import {WarehouseDirectSaleVariantsDetailFormSchemaType} from '../types/WarehouseDirectSaleVariantsDetailFormSchema';

const DEFAULT_RATIO_PERCENTAGE = 100;
const DEFAULT_MARGIN_PERCENTAGE = 0;

// Percentages shown in the form are stored as decimal values. An emptied ratio field falls back to
// 100 % and an emptied margin field to 0 %, so the variant never ends up with a missing ratio.
export function buildGeneralPatchBody(
  general: WarehouseDirectSaleVariantsDetailFormSchemaType['general']
) {
  // Since branchId is read-only, we don't want to send it back to server
  const {branchId: _branchId, restrictSaleBelowCost, ...rest} = general;

  return {
    ...rest,
    priceTypeRatio: percentageToDecimalValue(rest.priceTypeRatio ?? DEFAULT_RATIO_PERCENTAGE),
    rateTypeRatio: percentageToDecimalValue(rest.rateTypeRatio ?? DEFAULT_RATIO_PERCENTAGE),
    minimalMaterialMargin: percentageToDecimalValue(
      rest.minimalMaterialMargin ?? DEFAULT_MARGIN_PERCENTAGE
    ),
    minimalWorkMargin: percentageToDecimalValue(
      rest.minimalWorkMargin ?? DEFAULT_MARGIN_PERCENTAGE
    ),
    // Without the flag the field is left out, so the back-end keeps the stored value.
    restrictSaleBelowCost: isFeatureEnabled(featureFlags.AFS_WAREHOUSE_ACL_SCOPES)
      ? restrictSaleBelowCost
      : undefined,
  };
}
